import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  phoneVerificationContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    minHeight: '31.25rem',
    marginTop: '1rem',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      minHeight: '50rem',
    },
  },
  // screenContentWrap: {
  //   [theme.breakpoints.down('md')]: {
  //     minHeight: '17rem'
  //   },
  // },
  contentPosition: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
  },
  phoneVerificationText: {
    marginBottom: '1rem',
    fontSize: 25,
    textAlign: 'center',
    fontWeight: '500',
    color: theme.palette.common.black,
  },
  codeInfoText: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: '2.25rem',
  },
  codeInfoTextPh: {
    color: theme.palette.common.lightBlack,
    fontWeight: '500'
  },
  codeInputWrap: {
    marginBottom: '1.5rem',
    justifyContent: 'center'
  },
  codeInput: {
    borderRadius: 10,
    border: '1px solid #707070',
    fontSize: '20px',
    [theme.breakpoints.down(380)]: {
      marginRight: '5px !important'
    },
    '&:last-child': {
      marginRight: '0 !important'
    }
  },
  remainingTimeText: {
    fontWeight: '500',
    fontSize: 14,
    marginBottom: '1.25rem',
  },
  remainingTime: {
    fontWeight: '600',
    color: theme.palette.common.black,
  },
  resendButtonStyle: {
    fontSize: 14,
    textTransform: 'capitalize',
    border: 'none',
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: 0,
    boxShadow: 'none',
    minWidth: 0,
    margin: '0 0 0.5rem 1.25rem',
    color: '#16497B !important',
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'transparent',
    },
    '&:disabled': {
      color: '#707070 !important',
      textDecoration: 'underline',
    },
    '& .MuiCircularProgress-root': {
      color: '#000'
    }
  },
  noNumberAccess: {
    width: '100%',
    margin: 0,
    marginTop: '2.25rem'
  },
  btnContentWrap: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    left: '0',
    bottom: '-75px',
    [theme.breakpoints.down('md')]: {
      bottom: '-150px',
    },
    '& .MuiCircularProgress-root': {
      color: '#fff'
    }
  },
  phVeriBtn: {
    minWidth: 115
  },
  prevBtn: {
    marginLeft: '0.5rem'
  },
  nextBtn: {
    marginRight: '0.5rem'
  }
}));
